import React, { useEffect } from 'react';
import WatchAndWhitelistTable from '../../../../../components/ns/WatchAndWhitelistTable';
import PropTypes from 'prop-types';
import Wait4Me from '../../../../../components/Wait4Me';
import styles from './index.scss';

import { isResourceAvailable } from '../../../../../util';
import { getSelectedResources } from '../../../../../util/resourceManager';
const { nsResources } = getSelectedResources();

const resourceCode = nsResources.APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE;

const SelectWhiteList = (props) => {
  const { apiActions = {}, settings, authentication } = props;
  const { getNSRIWhiteListInitiate = {} } = apiActions;

  // Side Effects
  useEffect(() => {
    // WhiteList API
    getNSRIWhiteListInitiate({});
  }, []);

  // To Get Global Settings Configuration
  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  // Global Settings config
  const GS = getGSConfig({
    widgetGroupId: 'NS_IAD_LIST_WHITELIST',
    widgetId: 'NS_IAD_LIST_WHITELIST'
  });

  return (
    <div className={styles.whiteListContainer}>
      {settings?.nsSetting?.isLoading ? (
        <div className={styles.loadingWrapper}>
          <Wait4Me />
        </div>
      ) : (
        <WatchAndWhitelistTable
          {...props}
          GS={GS}
          hasRowSelection={true}
          hasPagination={true}
          component="SelectWhiteList"
          hasExecuteAccessToSelect={isResourceAvailable(
            authentication,
            resourceCode
          )}
        />
      )}
    </div>
  );
};

SelectWhiteList.propTypes = {
  apiActions: PropTypes.shape({
    getNSRIWhiteListInitiate: PropTypes.func
  }),
  settings: PropTypes.object,
  authentication: PropTypes.object
};

export default SelectWhiteList;
